import request from '@/request/http'

// 本文件接口统一走 /ai（http.js 默认是 /api），仅覆盖 baseURL，其余配置与拦截器不变
const aiRequest = (config) => request({ ...config, baseURL: '/ai' })

///获取会话列表（分页）
export function chatList(data) {
  return aiRequest({
    url: `/ai-chat/ClientChat/pageSession`,
    method: 'post',
    data: data
  })
}

///获取聊天记录
export function chatRecords(sessionId) {
  return aiRequest({
    url: `/ai-chat/ClientChat/getSessionHistory/${sessionId}`,
    method: 'get',
  })
}

///删除会话记录
export function delChatRecords(sessionId) {
  return aiRequest({
    url: `/ai-chat/chat/deleteSession/${sessionId}`,
    method: 'DELETE',
  })
}

///重命名会话
export function renameConversation(data) {
  return aiRequest({
    url: `/ai-chat/chat/updateSession`,
    method: 'put',
    data: data
  })
}

///获取模型助手列表
export function findQuestionAnswerModelConfigList(data) {
  return aiRequest({
    url: `/ai-chat/modelConfig/pageModelConfig`,
    method: 'post',
    data: data
  })
}

///上传解析文件（返回 blob）
export function uploadFileAsync(data) {
  return aiRequest({
    url: `/ai-chat/file/uploadFileAsync`,
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}

///获取文件解析进度
export function getProgress(taskId) {
  return aiRequest({
    url: `/ai-chat/file/getProgress/${taskId}`,
    method: 'get',
  })
}

///获取文件内容
export function getFileContent(taskId) {
  return aiRequest({
    url: `/ai-chat/file/getFileContent/${taskId}`,
    method: 'get',
  })
}
